export default "__VITE_PUBLIC_ASSET__8bba2306__"